var EIconButtonElements = /* @__PURE__ */ ((EIconButtonElements2) => {
  EIconButtonElements2["ROOT"] = "ROOT";
  return EIconButtonElements2;
})(EIconButtonElements || {});
var VIconButtonVariants = /* @__PURE__ */ ((VIconButtonVariants2) => {
  VIconButtonVariants2["primary"] = "primary";
  VIconButtonVariants2["secondary"] = "secondary";
  VIconButtonVariants2["tertiary"] = "tertiary";
  VIconButtonVariants2["plain"] = "plain";
  VIconButtonVariants2["carousel"] = "carousel";
  return VIconButtonVariants2;
})(VIconButtonVariants || {});
var VCloseIconButtonVariants = /* @__PURE__ */ ((VCloseIconButtonVariants2) => {
  VCloseIconButtonVariants2["tertiary"] = "tertiary";
  VCloseIconButtonVariants2["plain"] = "plain";
  return VCloseIconButtonVariants2;
})(VCloseIconButtonVariants || {});
export { VIconButtonVariants, EIconButtonElements, VCloseIconButtonVariants };
